import { render, staticRenderFns } from "./ic-monitoring-updates.vue?vue&type=template&id=223f73be"
import script from "./ic-monitoring-updates.vue?vue&type=script&lang=js"
export * from "./ic-monitoring-updates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_lodash@4.18.1_prettier@1.19.1_vue-temp_kahsjrgllpojn2i7cocf57twvu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports